import Skeleton from 'antd/lib/skeleton';

function ManagementPageSkeleton({ statsCount = 3, toolbarCount = 3, rowCount = 5, showAction = true }) {
  return (
    <div className="management-skeleton" aria-label="Loading management page">
      <div className="kb-page__header management-skeleton__header">
        <div className="management-skeleton__title">
          <Skeleton active title={{ width: 180 }} paragraph={{ rows: 1, width: ['52%'] }} />
        </div>
        {showAction ? <Skeleton.Button active className="management-skeleton__action" /> : null}
      </div>

      <section className="kb-page__overview management-skeleton__overview">
        <Skeleton active title={{ width: 210 }} paragraph={{ rows: 1, width: ['65%'] }} />
      </section>

      <div className="kb-page__workspace">
        <section className="kb-stats management-skeleton__stats" aria-label="Loading stats">
          {Array.from({ length: statsCount }).map((_, index) => (
            <article key={`stats-skeleton-${index}`} className="kb-stat-card">
              <Skeleton active title={{ width: '60%' }} paragraph={{ rows: 1, width: ['35%'] }} />
            </article>
          ))}
        </section>

        <section className="kb-articles management-skeleton__table-wrap" aria-label="Loading table">
          <div className="kb-articles__header">
            <Skeleton active title={{ width: 170 }} paragraph={false} />
          </div>

          <div className={`management-skeleton__toolbar management-skeleton__toolbar--${toolbarCount}`}>
            {Array.from({ length: toolbarCount }).map((_, index) => (
              <Skeleton.Input key={`toolbar-skeleton-${index}`} active block />
            ))}
          </div>

          <div className="management-skeleton__table">
            {Array.from({ length: rowCount }).map((_, index) => (
              <Skeleton
                key={`row-skeleton-${index}`}
                active
                title={{ width: `${50 + ((index % 4) + 1) * 8}%` }}
                paragraph={{ rows: 1, width: ['88%'] }}
              />
            ))}
          </div>
        </section>
      </div>
    </div>
  );
}

export default ManagementPageSkeleton;
